module.exports = __webpack_public_path__ + "static/media/16a-01-HOME_Camouflage2-2016-1524x3048mm-oleo-sobre-madera.7316eeb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/16a/16a-01-HOME_Camouflage2-2016-1524x3048mm-oleo-sobre-madera.jpg
// module id = 183
// module chunks = 0